import { render, staticRenderFns } from "./PanchoWillies_dessertSection.vue?vue&type=template&id=8664e934&scoped=true"
import script from "./PanchoWillies_dessertSection.vue?vue&type=script&lang=ts"
export * from "./PanchoWillies_dessertSection.vue?vue&type=script&lang=ts"
import style0 from "./PanchoWillies_dessertSection.vue?vue&type=style&index=0&id=8664e934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8664e934",
  null
  
)

export default component.exports